import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UserImageContextProps {
  userImage: string | null | undefined;
  setUserImage: React.Dispatch<React.SetStateAction<string | null | undefined>>;
}

const UserContext = createContext<UserImageContextProps | undefined>(undefined);

export const UserImageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [userImage, setUserImage] = useState<string | null | undefined>(null);

  return (
    <UserContext.Provider value={{ userImage, setUserImage }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserImage = (): UserImageContextProps => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
